import React, { createContext, useState, useEffect } from 'react';

export const GlobalStateContext = createContext();

export const GlobalStateProvider = ({ children }) => {
  const [bggUsers, setBggUsers] = useState([]);
  const [geeklistMeta, setGeeklistMeta] = useState({});
  const [geeklistItems, setGeeklistItems] = useState([]);
  const [usernameValue, setUsernameValue] = useState('');
  const [controlState, setControlState] = useState(false);
  const [isPriceHistoryExpanded, setIsPriceHistoryExpanded] = useState(false);
  const [isGridExpanded, setIsGridExpanded] = useState(false);
  
  // Row count tracking for different components
  const [rowCount, setRowCount] = useState(0); // bgg-list component
  const [researchRowCount, setResearchRowCount] = useState(0); // research component
  const [sellRowCount, setSellRowCount] = useState(0); // sell component
  
  // Dark mode state - initialize from localStorage or system preference
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const savedMode = localStorage.getItem('darkMode');
    if (savedMode !== null) {
      return savedMode === 'true';
    }
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  // Apply dark mode theme attribute to document and persist to localStorage
  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.setAttribute('data-theme', 'dark');
    } else {
      document.documentElement.removeAttribute('data-theme');
    }
    localStorage.setItem('darkMode', isDarkMode);
  }, [isDarkMode]);

  const toggleDarkMode = () => {
    setIsDarkMode(prev => !prev);
  };

  return (
    <GlobalStateContext.Provider value={{ 
      bggUsers, 
      setBggUsers, 
      geeklistMeta, 
      setGeeklistMeta, 
      geeklistItems, 
      setGeeklistItems, 
      usernameValue, 
      setUsernameValue, 
      controlState, 
      setControlState,
      isPriceHistoryExpanded,
      setIsPriceHistoryExpanded,
      isGridExpanded,
      setIsGridExpanded,
      rowCount,
      setRowCount,
      researchRowCount,
      setResearchRowCount,
      sellRowCount,
      setSellRowCount,
      isDarkMode,
      toggleDarkMode
    }}>
      {children}
    </GlobalStateContext.Provider>
  );
};